import React, { useEffect, useState } from "react";
import { CoreValuCard, CoreValuContainer } from "./styles";
import { Border } from "../../EventDetails/styles";
import { fetchApi } from "../../../utils/methods";
import { GetArchivedCoreValues, UpdateCompanyCoreValueStatus } from "../../../redux/constants/apiConstants";
import LazyImage from "../../common/LazyImage/LazyImage";
import { ImageUrl } from "../../../utils/constants";
import {
  AdminDeleteIcon,
  RecognitionDeleteIcon,
  RecognitionRestoreIcon,
  RecognitionTickIcon,
  RecognitionWarningIcon,
  RestoreIcon,
} from "../../../utils/icons";
import CommonModal from "../../common/CommonModal/CommonModal";
import { ManagerIconContainer } from "../../Manager/styles";
import SkeletonLoder from "../../common/skeletonLoder";
import PropTypes from "prop-types";
import { toast } from "react-toastify";

export const ArchiveLibraryTab = ({ companyInfo }) => {
  const [coreValues, setCoreValues] = useState([]);
  const [isArchive, setIsArchive] = useState(false);
  const [selectedCoreValues, setSelectedCoreValues] = useState([]);
  const [restoreModal, setRestoreModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetCompanyCoreValues(companyInfo.id);
  }, []);

  const GetCompanyCoreValues = async (companyId) => {
    setLoading(true);
    const res = await fetchApi(GetArchivedCoreValues + "/" + companyId, "GET");

    if (res.status === "success") {
      setCoreValues(res.data);
      setLoading(false);
      setSelectedCoreValues([]);
    }
  };

  const updateCoreValueData = async (payload) => {
    try {
      const res = await fetchApi(UpdateCompanyCoreValueStatus + "/" + companyInfo.id, "PUT", payload);
      if (res.data.message) {
        toast.error(res?.data?.message);
      } else {
        toast.success(res?.data[0]);
        GetCompanyCoreValues(companyInfo.id)
      }
    } catch (error) {
      // toast.error(error)
    }
  }

  const SelectCoreValue = (id) => {
    const allCoreValues = [...selectedCoreValues];
    if (allCoreValues.includes(id)) {
      let index = allCoreValues.findIndex((item) => item === id);
      if (index > -1) {
        allCoreValues.splice(index, 1);
      }
    } else {
      allCoreValues.push(id);
    }

    setSelectedCoreValues(allCoreValues);
  };


  const handleCancel = () => {
    setSelectedCoreValues([]);
    setIsArchive(false);
  };


  const handleRestoreCancel = () => {
    setRestoreModal(false);
  };

  const handleRestoreConfirm = () => {
    const postobject = {
      core_value_ids: selectedCoreValues,
      type: "restore"
    }
    if (selectedCoreValues?.length === 0) {
      toast.error("Please select atleast one core value to restore")
      setRestoreModal(false);
    } else {
      setRestoreModal(false);
      updateCoreValueData(postobject)
    }

  };


  const handleDeleteCancel = () => {
    setDeleteModal(false);
  };

  const handleDeleteModal =()=>{
    if(selectedCoreValues?.length === 0){
      toast.error("Please select atleast one core value to delete");
    }
    else{
      setDeleteModal(true)
    }
  } 

  const handleRestoreModal =()=>{
    if(selectedCoreValues?.length === 0){
      toast.error("Please select atleast one core value to restore");
    }
    else{
      setRestoreModal(true);
    }
  } 

  const handleDeleteConfirm = () => {
    const postobject = {
      core_value_ids: selectedCoreValues,
      type: "delete"
    }
    // if (selectedCoreValues.length === 0) {
    //   toast.error("Please select atleast one core value to delete");
    //   setDeleteModal(false);
    // } else {
    setDeleteModal(false);
    updateCoreValueData(postobject);
    // }

  };


  return (
    <>
      {loading ? <SkeletonLoder width={"1246px"} height={"500px"} /> : <><CoreValuContainer>
        <div className="top-bar-container">
          <div id="activeCoreValues" className="header">Core Values</div>
          {isArchive ? (
            <div className="archive-active">
              <div id="restore-icon"  
                onClick = {handleRestoreModal}> 
                {RecognitionRestoreIcon()}
              </div>
              <div id="delete-icon"
                onClick = {handleDeleteModal}
                style={{ margin: "0px 16px" }}>
                {RecognitionDeleteIcon()}
              </div>
              <div
                className="cancel-archive"
                onClick={() => handleCancel()}
              >
                Cancel
              </div>
            </div>
          ) : coreValues?.length > 0 ? <div id="restore-delete" className="archive" onClick={() => setIsArchive(true)}>
              Restore/Delete</div> :null
          }
        </div>
        <Border style={{ border: "1px solid #EFEFEF", margin: "20px 0px" }} />

        {coreValues?.length > 0 ? <div className="core-values">
          {coreValues.map((coreValue, index) => (
            <>
              <div className="border-btm">
                <CoreValuCard
                  key={index}
                  selected={
                    selectedCoreValues.includes(coreValue.id) ? true : false
                  }
                >
                  <div className="core-value-row">
                    <div className="col-one">
                      <div
                        className="icon"
                        style={{ background: coreValue?.recognition_color_value }}
                      >
                        {coreValue?.white_icon ? <LazyImage
                          style={{ width: "24px" }}
                          src={ImageUrl + "/" + coreValue?.white_icon}
                        /> : null}
                      </div>
                      <div className="title">{coreValue?.core_value}</div>
                    </div>
                    <div className="action">
                      <ManagerIconContainer>
                        {isArchive ? (
                          <div
                            className="archive-action"
                            onClick={() => SelectCoreValue(coreValue.id)}
                          >
                            {selectedCoreValues.includes(coreValue.id)
                              ? RecognitionTickIcon()
                              : null}
                          </div>
                        ) : null}
                      </ManagerIconContainer>
                      {/* {isArchive ? <div className="archive-action"></div> : <div className="eye-icon">{RecognitionLaunchIcon("#F37A65")}</div>} */}
                      {/* <div className="pencil-icon">{RecognitionPencilIcon()}</div> */}
                    </div>
                  </div>
                </CoreValuCard>
              </div>
            </>
          ))}
        </div>:<div className="no-data">There are No Core Values to Restore or Delete.</div> }
        {restoreModal && <CommonModal
          show={restoreModal}
          icon={RecognitionWarningIcon("#B1AA56")}
          title="Restore Core Values"
          description="Once restored, they will appear in the Active tab. Would you like to restore these core values now? "
          onCancel={handleRestoreCancel}
          onConfirm={handleRestoreConfirm}
          cancelText="Cancel"
          confirmButtonText="Restore Now"
          buttonIcon={RestoreIcon()}
          modalHeight="231px"
          confirmButtonWidth="148px"
        />
        }
        {deleteModal && <CommonModal
          show={deleteModal}
          icon={RecognitionWarningIcon("#C13D4D")}
          title="Delete Core Values"
          description="Are you sure you want to delete these core value?"
          subDescription="This action cannot be undone, and the core value will be permanently removed from the system."
          onCancel={handleDeleteCancel}
          onConfirm={handleDeleteConfirm}
          cancelText="Cancel"
          confirmButtonText="Delete Permanently"
          buttonIcon={AdminDeleteIcon()}
          confirmButtonWidth="198px"
          modalHeight="275px"
        />
        }


      </CoreValuContainer>
      </>}
    </>
  );
};


ArchiveLibraryTab.propTypes = {
  history: PropTypes.object.isRequired,
  companyInfo: PropTypes.object.isRequired,
};